/**
 * メッセージソース.
 *
 * @author Nakagawa_Michio@ogis-ri.co.jp
 *
 */
export default class MessageSource {
  /**
   * デフォルト言語.
   */
  lang: string

  /**
   * メッセージソース.
   */
  messages: object = {
    en: {
      hello: 'hello',
    },
    ja: {
      hello: 'こんにちは',
    },
    zh: {
      hello: '您好',
    },
  }

  /**
   * コンストラクタ.
   *
   * @param messages メッセージソース.
   * @param lang デフォルト言語.
   */
  constructor(messages: object, lang: string) {
    this.messages = messages
    this.lang = lang
  }

  /**
   * メッセージを取得する.
   *
   * @param key メッセージキー.
   * @param lang 言語. e.g.) 'en', 'ja', 'zh'
   * @param args 引数（オプション）
   */
  getMessageByLang(key: string, lang: string, ...args: any) {
    return this.format(this.message(key, lang), args)
  }

  /**
   * メッセージを取得する.
   *
   * @param key メッセージキー.
   * @param args 引数（オプション）
   */
  getMessage(key: string, ...args: any) {
    return this.format(this.message(key, this.lang), args)
  }

  /**
   * メッセージテンプレートを取得する.
   *
   * @param key メッセージキー.
   * @param lang 言語. e.g.) 'en', 'ja', 'zh'
   */
  private message(key: string, lang: string): string {
    const msgs: any = this.messages;
    let locale: any = msgs[lang] ?
      msgs[lang] :
      msgs[this.lang] ? msgs[this.lang] : Object()
    return locale[key] ? locale[key] : `?${key}?`
  }

  /**
   * メッセージテンプレートをフォーマットする.
   *
   * @param message メッセージテンプレート.
   * @param args 引数.
   * @returns 変更後のメッセージ.
   */
  private format(message: string, args: any[]): string {
    let result: string = message
    args.forEach(function(value: any, i: number) {
      let placeholder: string = `{${i}}`
      result = result.replace(placeholder, value)
    })
    return result
  }
}